/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { headerTeamMemberDtoSchema } from "./headerTeamMemberDtoSchema.ts";
import { z } from "zod/v4";

export const headerTeamSizeDtoSchema = z.object({
  headcount: z.optional(z.int()),
  founders: z.optional(z.int()),
  description: z.optional(z.string()),
  get members() {
    return z.array(headerTeamMemberDtoSchema).optional();
  },
  foundedYear: z.int().nullish(),
});
